import { z } from 'zod'
import { RegistrationSchema } from './booking'

export const SNAG_STATUSES = ['open', 'closed'] as const
export type SnagStatus = (typeof SNAG_STATUSES)[number]

// A row of GET /api/aircraft-snags.
export interface AircraftSnag {
  snagId: number
  registration: string
  title: string
  issue: string
  status: SnagStatus
  followUp: string
  followUpBy: string
  notes: string
  createdBy: string | null
  createdByName: string | null
  createdAt: string
  closedAt: string | null
}

const text = (max: number) => z.string().trim().max(max)

export const CreateSnagSchema = z.object({
  registration: RegistrationSchema,
  title: text(200).min(1),
  issue: text(2000).default(''),
  followUp: text(1000).default(''),
  followUpBy: text(200).default(''),
  notes: text(4000).default(''),
})

export const UpdateSnagSchema = z
  .object({
    title: text(200).min(1),
    issue: text(2000),
    status: z.enum(SNAG_STATUSES),
    followUp: text(1000),
    followUpBy: text(200),
    notes: text(4000),
  })
  .partial()
